import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteUserMutation } from "../../services/appln";

export default function UserDelete(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteUserMutation}
      deleteArgs={{ userId: props.userId }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteUserTitle}
      confirmationDialogMsg={strings.deleteUserConfirmation}
      errorDialogTitle={strings.deleteUserFailedTitle}
      errorDialogMsg={strings.deleteUserFailedMsg}
    />
  );
}
